import React, { useEffect, useState } from "react";
import { Button, Card, Col, Form, Modal, Row } from "react-bootstrap";
import Heading from "Components/Heading";
import Footer from "Components/Footer";
import SampleDataTable from "Components/DataTables";
import ReasonAPIs from "../../APIs/reason";
import { toast } from "react-toastify";
import { Formik } from "formik";
import * as Yup from "yup";
import { FaRegEdit, FaRegTrashAlt } from "react-icons/fa";

const Reason = () => {
  const [reason, setReason] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const [showModal, setShowModal] = useState(false); // State to control modal visibility
  const [modalMode, setModalMode] = useState("add"); // 'add' or 'edit'
  const [currentEditItem, setCurrentEditItem] = useState(null);

  // To open modal in add mode
  const handleShowAdd = () => {
    setModalMode("add");
    setCurrentEditItem(null);
    setShowModal(true);
  };

  // To open modal in edit mode
  const handleShowEdit = (item) => {
    setModalMode("edit");
    setCurrentEditItem(item);
    setShowModal(true);
  };

  const editReason = async (data, resetForm) => {
    setIsLoading(true);
    try {
      // Assuming your API has an editDocTypeById method
      await ReasonAPIs.updateReasonById(currentEditItem.id, data);
      toast.success("Reason Updated Successfully.");
      setShowModal(false); // Close modal after submission
      getAllReason(); // Refresh the list
    } catch (error) {
      toast.error("Failed to update Reason.");
    }
    setIsLoading(false);
  };

  const validationSchema = Yup.object().shape({
    name: Yup.string().required("Reason Name. is required"),
  });

  const submitHandler = async (data, resetForm) => {
    setIsLoading(true);
    const res = await ReasonAPIs.createReason(data);
    if (res) {
      toast.success("Reason Added Successfully.");
      resetForm({ values: "" });
      setShowModal(false); // Close modal after submission
      getAllReason();
    }
    setIsLoading(false);
  };

  const getAllReason = async () => {
    const reason = await ReasonAPIs.getReason();
    if (reason) {
      setReason(reason.data.data);
    }
  };

  useEffect(() => {
    getAllReason();
  }, []);

  // Function to handle modal close
  const handleClose = () => setShowModal(false);
  // Function to handle modal show
  const handleShow = () => setShowModal(true);

  return (
    <>
      <section>
        <Heading text={"Reason"} />
        <Card>
          <Button
            variant="primary"
            onClick={handleShowAdd}
            size="sm"
            style={{ width: "150px", marginBottom: "20px" }}
          >
            Add Reason
          </Button>

          {/* Popup Add-Edit */}
          <Modal show={showModal} onHide={handleClose}>
            <Modal.Header closeButton>
              <Modal.Title>Add Reason</Modal.Title>
            </Modal.Header>
            <Modal.Body>
              <Formik
                onSubmit={(values, { resetForm }) => {
                  //submitHandler(values, resetForm);
                  if (modalMode === "add") {
                    submitHandler(values, resetForm); // Your existing add functionality
                  } else {
                    // Call edit API
                    editReason(values, resetForm);
                  }
                }}
                initialValues={{
                  name:
                    modalMode === "edit" && currentEditItem
                      ? currentEditItem.name
                      : "",
                }}
                validationSchema={validationSchema}
                validateOnChange={false}
              >
                {({ handleSubmit, handleChange, values, errors }) => (
                  <Form onSubmit={handleSubmit}>
                    <Form.Group className="mb-3">
                      <Form.Label>Reason Name</Form.Label>
                      <Form.Control
                        type="text"
                        name="name"
                        onChange={handleChange}
                        value={values.name}
                        isInvalid={!!errors.name}
                      />
                      <Form.Control.Feedback type="invalid">
                        {errors.name}
                      </Form.Control.Feedback>
                    </Form.Group>
                    <Button variant="primary" type="submit">
                      Save Changes
                    </Button>
                  </Form>
                )}
              </Formik>
            </Modal.Body>
          </Modal>
          {/* Listing Table */}
          <SampleDataTable
            columns={[
              { accessor: "name", Header: "Reason" },
              {
                accessor: "id",
                Header: "Action",
                Cell: ({ row }) => (
                  <>
                    <Button
                      className="me-3"
                      onClick={() => handleShowEdit(row.original)}
                    >
                      <FaRegEdit />
                    </Button>
                    <Button
                      variant="danger"
                      className="me-3"
                      onClick={async () => {
                        const isConfirmed = window.confirm(
                          "Are you sure you want to delete this Reason?"
                        );
                        if (isConfirmed) {
                          // Call delete API

                          setIsLoading(true);
                          try {
                            await ReasonAPIs.deleteReasonById(row.original.id);
                            toast.success("Reason Deleted Successfully.");
                            getAllReason(); // Refresh the list
                          } catch (error) {
                            toast.error("Failed to delete Reason.");
                          }
                          setIsLoading(false);
                        }
                      }}
                    >
                      <FaRegTrashAlt />
                    </Button>
                  </>
                ),
              },
            ]}
            data={reason}
          />
          <Footer />
        </Card>
      </section>
    </>
  );
};

export default Reason;
